(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/tabs/assets/javascripts/tabs.js') >= 0) return;  svs.modules.push('/components/components/tabs/assets/javascripts/tabs.js');

var svs = svs || {};


svs.components = svs.components || {};

svs.components.Tabs = function(options) {
  var tabEl = $(options.el);
  var navItemsEl = $(options.navItemsEl);
  var navContentEl = $(options.navContentEl);
  var useSplitTab = options.useSplitTab;
  var solidNav = options.solidNav;
  var followUrl = options.followUrl;
  var fixedStartTab = options.fixedStartTab;
  var useDefaultScroll = options.defaultScroll;
  var useStickyNav = options.stickyNav;
  var tabTabsEl;
  var tabTabsWrapperEl;
  var tabContentEl;
  var tabContentWrapperEl;
  var tabMarkup = '<div class="js-slider-slide slider-slide"></div>';
  var tabLinkMarkup = '<a class="js-slider-slide slider-slide"></a>';
  var currentTab;
  var tabsSlider;
  var contentSlider;
  var self;

  function init() {
    initPlugins();

    setupMarkup();
    options.cssClass = options.cssClass || '';
    tabEl.addClass(options.cssClass);
    tabEl.addClass('tabs-container');

    if (useSplitTab) {
      options.navCssClass = options.navCssClass || '';
      navItemsEl.addClass(options.navCssClass);

      options.contentCssClass = options.contentCssClass || '';
      navContentEl.addClass(options.contentCssClass);
    }
    if (options.tabs) {
      addTabs(options.tabs);
    }

    tabsSlider = new svs.components.Slider(tabTabsEl, {
      center: true,
      startIndex: options.startIndex || 0,
      slideOnDrag: false,
      slideOnClick: true,
      solidNav: solidNav,
      followUrl: followUrl,
      fixedStartSlide: fixedStartTab
    });
    contentSlider = new svs.components.Slider(tabContentEl, {
      center: false,
      bouncing: false,
      startIndex: options.startIndex || 0,
      slideOnDrag: options.slideOnDrag,
      toggleSlide: solidNav
    });

    self.tabsSlider = tabsSlider;
    self.contentSlider = contentSlider;

    tabsSlider.setControl(contentSlider);
    contentSlider.setControl(tabsSlider);

    initEvents();

    resize();

    setTimeout(function() {
      resize();
    }, 100);

    var tabIndex = options.startIndex || 0;
    var tab = options.tabs ? options.tabs[tabIndex] : null;
    var el = contentSlider.getSlides()[tabIndex];

    self.trigger('init', { index: tabIndex, el: el, tab: tab });
  }

  function setupMarkup() {
    if (useSplitTab) {
      navItemsEl.addClass(useStickyNav && 'product-base-nav-sticky');
      navContentEl.addClass(useStickyNav && 'product-base-content-sticky');

      tabTabsEl = navItemsEl.find('.js-tabs-tabs');
      tabContentEl = navContentEl.find('.js-tabs-content');

      if (tabTabsEl.length === 0) {
        tabTabsEl = $('<div class="js-tabs-tabs tabs-tabs slider-container">').append($('<div class="js-slider-wrapper slider-wrapper">').addClass(solidNav && 'tabs-overflow-x'));
        navItemsEl.append(tabTabsEl);
      }

      if (tabContentEl.length === 0) {
        tabContentEl = $('<div class="js-tabs-content tabs-content slider-container">').append('<div class="js-slider-wrapper slider-wrapper">');
        navContentEl.append(tabContentEl);
      }
      tabTabsWrapperEl = navItemsEl.find('.js-slider-wrapper');
      tabContentWrapperEl = navContentEl.find('.js-slider-wrapper');
    } else {
      tabEl
        .find('.js-product-base-tabs-nav')
        .addClass(useStickyNav && 'product-base-nav-sticky');
      tabEl
        .find('.js-product-base-tabs-content')
        .addClass(useStickyNav && 'product-base-content-sticky');

      tabTabsEl = tabEl.find('.js-tabs-tabs');
      tabContentEl = tabEl.find('.js-tabs-content');

      if (tabTabsEl.length === 0) {
        tabTabsEl = $('<div class="js-tabs-tabs tabs-tabs slider-container">').append($('<div class="js-slider-wrapper slider-wrapper">').addClass(solidNav && 'tabs-overflow-x'));
        tabEl.append(tabTabsEl);
      }

      if (tabContentEl.length === 0) {
        tabContentEl = $('<div class="js-tabs-content tabs-content slider-container">').append('<div class="js-slider-wrapper slider-wrapper">');
        tabEl.append(tabContentEl);
      }
      tabTabsWrapperEl = tabTabsEl.find('.js-slider-wrapper');
      tabContentWrapperEl = tabContentEl.find('.js-slider-wrapper');
    }
  }

  function initPlugins() {
    if (svs.components.tabPlugins) {
      if (useDefaultScroll) {
        $.each(svs.components.tabPlugins, function(index, plugin) {
          if (index !== 'resize') {
            plugin.call(self, options);
          }
        });
      } else {
        $.each(svs.components.tabPlugins, function(index, plugin) {
          plugin.call(self, options);
        });
      }
    }
  }

  function initEvents() {
    contentSlider.on('change', function(tab) {
      var currentTab = $(tab.el);

      if (!solidNav) {
        tabContentEl.height(currentTab.height());
      }

      self.trigger('change', {
        index: tab.index,
        el: tab.el,
        tab: options.tabs ? options.tabs[tab.index] : null
      });

      if (
        options.tabs &&
        options.tabs[tab.index] &&
        options.tabs[tab.index].view &&
        options.tabs[tab.index].view.props &&
        options.tabs[tab.index].view.props.onTabChange
      ) {
        options.tabs[tab.index].view.props.onTabChange();
      }
    });
  }

  function addTabs(tabs) {
    var slideClass; var tabClass;

    for (var i = 0, length = tabs.length; i < length; i++) {
      currentTab = tabs[i];
      tabClass = '';
      slideClass = currentTab.cssClass || '';

      if (slideClass === '' && options.cssClass.indexOf('rsInverted') >= 0) {
        slideClass = 'slide-inverted';
      }

      if (i === 0 && fixedStartTab) {
        tabClass = 'tabs-fixed-first-tab';
        tabTabsEl.addClass('tabs-fixed-first-tab-wrapper');
        var tabEl = tabTabsEl.find('.js-slider-slide').first();
        if (tabEl.length === 0) {
          tabEl = $(currentTab.href ? tabLinkMarkup : tabMarkup).html(currentTab.title || currentTab.caption);
          tabTabsEl.prepend(tabEl);
        }
        tabEl
          .addClass(tabClass)
          .attr('data-anchor', currentTab.anchor)
          .attr('data-content', currentTab.title || currentTab.caption)
          .attr('href', currentTab.href);
        tabTabsEl.css('padding-left', tabEl.outerWidth() + 5);
      } else if (
        tabTabsWrapperEl
          .find('.js-slider-slide')
          .eq(fixedStartTab ? i - 1 : i).length === 0
      ) {
        tabTabsWrapperEl.append($(currentTab.href ? tabLinkMarkup : tabMarkup)
          .addClass(tabClass)
          .attr('data-anchor', currentTab.anchor)
          .attr('data-content', currentTab.title || currentTab.caption)
          .attr('href', currentTab.href)
          .html(currentTab.title || currentTab.caption));
      }
      if (tabContentWrapperEl.find('.js-slider-slide').eq(i).length === 0) {
        tabContentWrapperEl.append($(tabMarkup)
          .addClass(slideClass)
          .html(currentTab.el));
      }
      if (useDefaultScroll) {
        var tab = tabContentWrapperEl.find('.js-slider-slide').eq(i);
        tab.addClass('product-base-default-scroll');
      }
    }
  }

  function resize() {
    if (useSplitTab) {
      if (navItemsEl && navItemsEl.length > 0) {
        if (!solidNav) {
          tabContentWrapperEl
            .find('.js-slider-slide')
            .css('width', navContentEl.outerWidth());
        }
        tabsSlider.resize();
        contentSlider.resize(contentSlider.getCurrentSlideIndex());

        if (options.tabs) {
          self.trigger(
            'resize',
            options.tabs[contentSlider.getCurrentSlideIndex()]
          );
        }

        if (!solidNav) {
          tabContentEl.height($(contentSlider.getCurrentSlide()).height());
        }
      }
    } else if (tabEl && tabEl.length > 0) {
      if (!solidNav) {
        tabContentWrapperEl
          .find('.js-slider-slide')
          .css('width', tabEl.outerWidth());
      }

      tabsSlider.resize();
      contentSlider.resize(contentSlider.getCurrentSlideIndex());

      if (options.tabs) {
        self.trigger(
          'resize',
          options.tabs[contentSlider.getCurrentSlideIndex()]
        );
      }
      if (!solidNav) {
        tabContentEl.height($(contentSlider.getCurrentSlide()).height());
      }
    }
  }

  function destroy() {
    self.trigger('destroy');

    tabsSlider.destroy();
    contentSlider.destroy();

    tabTabsEl.remove();
    tabTabsWrapperEl.remove();
    tabContentEl.remove();
    tabContentWrapperEl.remove();

    tabTabsEl = null;
    tabTabsWrapperEl = null;
    tabContentEl = null;
    tabContentWrapperEl = null;

    tabEl.empty();
    tabEl = null;

    if (this.options && _.isArray(this.options.tabs)) {
      for (var i = 0; i < this.options.tabs.length; ++i) {
        if (
          this.options.tabs[i].view &&
          _.isFunction(this.options.tabs[i].view.destroy)
        ) {
          this.options.tabs[i].view.destroy();
        }
      }
    }
  }

  function setActiveTab(tabIndex) {
    options.startIndex = tabIndex;
    tabsSlider.scrollTo(tabIndex);
  }

  self = new svs.core.Events({
    resize: resize,
    options: options,
    destroy: destroy,
    dispose: destroy,
    setActiveTab: setActiveTab
  });

  init();

  return self;
};


 })(window);